import Config from '../config/Config';
import { fetchJson } from './api';

export const lifecycleBaseUrl = Config.ApiBaseUrl;
export const lifecycleUrl = (path) => `${lifecycleBaseUrl}${path.replace(/^\//, '')}`;
export const requestJson = (path, options) => fetchJson(lifecycleUrl(path), options);
